import { BACKEND_ENTITY_TYPES, ENTITIES } from './common'

export const ACTIONS = ['manage', 'create', 'read', 'update', 'delete']

// https://github.com/SensorUp/su-user/blob/531dfe8047a13b8dc0f083e7755a8c5b53f85b11/src/lib/constants.js#L24-L55
export const SUBJECT_TYPES: Record<string, string> = {
  [BACKEND_ENTITY_TYPES.map]: 'Map',
  pipe: 'Pipe',
  [BACKEND_ENTITY_TYPES.rule]: 'Rule',
  [BACKEND_ENTITY_TYPES.user]: 'User',
  group: 'Group',
  issue: 'Issue',
  [BACKEND_ENTITY_TYPES.site]: 'Site',
  all: 'all',
  login: 'Login',
  eventHubSubscription: 'EventHubSubscription',
  assetProfile: 'AssetProfile',
  assetType: 'AssetType',
  assetTypeProperty: 'AssetTypeProperty',
  assetState: 'AssetState',
  [ENTITIES.form]: 'Form',
  procedure: 'Procedure',
  camDataset: 'CamDataset',
  catalog: 'Catalog',
  formList: 'FormList',
  emissionObservation: 'EmissionObservation',
  emissionEvent: 'EmissionEvent',
  reconciledEmissionEvent: 'ReconciledEmissionEvent',
  inspectionRequest: 'InspectionRequest',
  co2eEmissions: 'CO2EEmissions',
  cdrCalculationConfig: 'CdrCalculationConfig',
  cdrDataObservation: 'CdrDataObservation',
  cdrCalculationResult: 'CdrCalculationResult',
  cdrProjectConfig: 'CdrProjectConfig',
  cdrClientConfig: 'CdrClientConfig',
  fugitiveEmissionsDashboard: 'FugitiveEmissionsDashboard',
  [BACKEND_ENTITY_TYPES.asset]: 'Asset',
}
